import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { shareReplay, finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LogisticsCustomerService {

  baseUrl: string = `${environment.logisticsApiUrl}/customer`;
  private customerOptionsCache$: Observable<any> | null = null;

  constructor(private http: HttpClient) {

  }

  /**
   * Get Customer Options for DropDown
   */
  getCustomerOptions(isActivated: string): Observable<any> {
    // 資料存入快取避免重複打API
    if (!this.customerOptionsCache$) {
      const httpOptions = {
        params: {
          "isActivated": isActivated
        },
      };
      const url = this.baseUrl + `/customerOptions`;
        this.customerOptionsCache$ = this.http.post(url, null, httpOptions).pipe(
          shareReplay({ bufferSize: 1, refCount: true }),
          finalize(() => {
            // 離開頁面時，將快取清空
            this.customerOptionsCache$ = null;
          })
        );
    }
    return this.customerOptionsCache$;
  }

}
